import { render } from "./FarmForm.vue?vue&type=template&id=6b8a0a22"
import script from "./FarmForm.vue?vue&type=script&lang=js"
export * from "./FarmForm.vue?vue&type=script&lang=js"
script.render = render

export default script